import * as React from 'react';
import SearchByImage from './SearchByImage/SearchByImage';
import { match } from 'react-router-dom';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import './adhoc.css';
import { RoutesModules } from 'src/modules/Routing/types';

export interface IAdhocToolsProps {
  match: match<{ searchId: string }>;
  history?: History;
};

export class AdHocTools extends React.Component<IAdhocToolsProps, any>  {
  public render() {
    return (
      <div>
        <SearchByImage resultsId={this.props.match.params.searchId} history={this.props.history} />
      </div>
    );
  }
}

export default SidebarContainer(RoutesModules.SEARCH)(AdHocTools);